import React, { useEffect, useMemo, useState } from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

function PamAppSelect({ apps, value, onChange, isLoading }) {
  const [mainApp, setMainApp] = useState('')

  const normalApps = useMemo(
    () => (apps || []).filter((app) => !app.id.startsWith('14-')),
    [apps],
  )
  const singleApps = useMemo(
    () => (apps || []).filter((app) => app.id.startsWith('14-')),
    [apps],
  )
  const hasSingleApps = singleApps.length > 0

  useEffect(() => {
    if (!value) {
      return
    }
    if (value.startsWith('14-')) {
      setMainApp('14')
      return
    }
    setMainApp(value)
  }, [value])

  const handleMainChange = (nextMainApp) => {
    setMainApp(nextMainApp)
    if (nextMainApp === '14') {
      onChange('')
      return
    }
    onChange(nextMainApp)
  }

  const formatSingleAppName = (name) =>
    name?.startsWith('JPSingle ') ? name.replace('JPSingle ', '') : name

  const selectedSingleApp = value?.startsWith('14-') ? value : ''

  return (
    <div className="flex items-center gap-2">
      <Select value={mainApp} onValueChange={handleMainChange} disabled={isLoading}>
        <SelectTrigger className="w-[220px]">
          <SelectValue placeholder="选择应用" />
        </SelectTrigger>
        <SelectContent>
          {normalApps.map((app) => (
            <SelectItem key={app.id} value={app.id}>
              {app.name}
            </SelectItem>
          ))}
          {hasSingleApps && <SelectItem value="14">JPSingle</SelectItem>}
        </SelectContent>
      </Select>
      {mainApp === '14' && (
        <Select
          value={selectedSingleApp}
          onValueChange={onChange}
          disabled={isLoading}
        >
          <SelectTrigger className="w-[220px]">
            <SelectValue placeholder="选择单包应用" />
          </SelectTrigger>
          <SelectContent>
            {singleApps.map((app) => (
              <SelectItem key={app.id} value={app.id}>
                {formatSingleAppName(app.name)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  )
}

export default PamAppSelect

